var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrusted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "48px",
    viewBox: "0 0 47 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bank") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-367.000000, -3150.000000)",
    fill: "#0075F3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.458523,3150.40634 C389.764533,3149.86455 391.235477,3149.86455 392.541487,3150.40634 C400.080812,3153.53392 407.619305,3157.9272 413.034934,3163.64757 C415.273186,3166.01153 413.292079,3169.39207 410.419655,3169.39207 L407.70333,3169.39207 L407.70333,3184.11085 C409.085396,3184.56342 410.237118,3185.36719 411.153425,3186.42711 C412.562293,3188.05667 413.335541,3190.19224 413.718361,3192.34211 C414.299655,3195.60661 411.490612,3198 408.608771,3198 L372.391021,3198 C369.509,3198 366.700225,3195.60661 367.28145,3192.34211 C367.664256,3190.19224 368.437445,3188.05667 369.846295,3186.42711 C370.762747,3185.36719 371.914542,3184.56338 373.296536,3184.11081 L373.296536,3169.39207 L370.580282,3169.39207 C367.708,3169.39207 365.726871,3166.01153 367.964953,3163.64757 C373.380669,3157.9272 380.919198,3153.53392 388.458523,3150.40634 Z M402.270678,3183.696 L402.270678,3169.39207 L393.216258,3169.39207 L393.216258,3183.696 L402.270678,3183.696 Z M378.729187,3169.39207 L387.783607,3169.39207 L387.783607,3183.696 L378.729187,3183.696 L378.729187,3169.39207 Z",
    id: "Bank"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrusted);
export default __webpack_public_path__ + "static/media/trusted.a420863b9c93d2b576ac1cfb8dbf958d.svg";
export { ForwardRef as ReactComponent };